module.exports = __webpack_public_path__ + "static/whitecosysuitcase-2a6c0fc2b105b0030d39a5ee3c0985e4.jpeg";